export default {
  blank: () => import("/home/runner/work/mfx-framework/mfx-framework/apps/mfx-studio/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/home/runner/work/mfx-framework/mfx-framework/apps/mfx-studio/layouts/default.vue").then(m => m.default || m)
}